<template>
    <div class="chart" :ref="name" :style="{'height': height}"></div>
</template>
<script>
import * as echarts from 'echarts'
// require('echarts/theme/macarons') // echarts theme
import {debounce} from '@/assets/js/debounce.js'
const animationDuration = 6000;
export default {
    props: {
        name: {type: String},
        data: {type: Object},
        type: {type: String},
        theme: {type: String, default: function(){return 'light'}},
        height: {type: String, default: function(){return '100%'}},
        title: {type: String, default: function(){return ''}}
    },
    data(){
        return{
            chart: null,
        }
    },
    created(){
        
    },
    //初始化
    mounted() {
        this.initChart(this.data);
        this.resizeHandler = debounce(() => {
            if (this.chart) {
                this.chart.resize()
            }
        }, 100)
        window.addEventListener('resize', this.resizeHandler)
    },
    watch:{
        data:{
            immediate: true,
            deep:true,
            handler(newVal, oldVal){
                if (this.chart) {
                    if (newVal) {
                        this.initChart(newVal)
                    } else {
                        this.initChart(oldVal)
                    }
                }
            }
        }
    },
    //销毁
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        window.removeEventListener('resize', this.resizeHandler)
        this.chart.dispose()
        this.chart = null
    },
    methods:{
        getOption(type,data){
            var option;
            switch(type){
                case 'pie':
                    option = {
                        tooltip : {
                            trigger: 'item',
                            formatter: "{a} <br/>{b} : {c} ({d}%)"
                        },
                        legend: {
                            type: 'scroll',
                            orient: 'vertical',
                            right: '4%',
                            data:  data.lenged
                        },
                        grid: {
                            left: '4%',
                            right: '4%',
                            containLabel: true
                        },
                        series : [
                            {
                                name: data.name,
                                type: 'pie',
                                radius : '55%',
                                center: ['50%', '60%'],
                                data: data.data,
                                itemStyle: {
                                    emphasis: {
                                        shadowBlur: 10,
                                        shadowOffsetX: 0,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    }
                                }
                            }
                        ]
                    };
                    break;
                case 'line':
                    option = {
                        title: {
                            textStyle: {
                                fontWeight: "bold",
                                color: "#161616",
                                fontSize: 16
                            }
                        },
                        tooltip: {
                            trigger: 'axis',
                            formatter:function(params){
                                var dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:'+data.color+'"></span>'
                                var res='<div><p>'+dotHtml+'时间：'+params[0].name+'</p></div>'
                                for(var i=0;i<params.length;i++){
                                    res+='<p>'+dotHtml+params[i].seriesName+'：'+params[i].data+data.unit+'</p>'
                                }
                                return res;
                            }
                        },
                        legend: {
                            data: data.lenged
                        },
                        grid: {
                            left: '4%',
                            right: '4%',
                            containLabel: true
                        },
                        toolbox: {
                            show:false,
                            feature: {
                                saveAsImage: {}
                            },
                            right:'4%'
                        },
                        calculable: true,
                        xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data: data.xAxis,
                            axisLabel:{
                                color: "#999",
                                fontSize: 12,
                                fontWeight: "normal"
                            },
                            axisLine: {
                                lineStyle: {
                                    type: 'solid',
                                    color: 'rgba(193,193,193,1)',
                                    width:'1'
                                }
                            },
                            splitLine:{
                                show:false
                            }
                        },
                        yAxis: {
                            type: 'value',
                            axisLabel:{
                                color: "#999",
                                fontSize: 12,
                                fontWeight: "normal"
                            },
                            axisLine: {
                                lineStyle: {
                                    type: 'solid',
                                    color: 'rgba(193,193,193,1)',
                                    width:'1'
                                }
                            },
                            splitLine:{
                                show:false
                            }
                        },
                        series: [{
                            name: data.name,
                            type: 'line',
                            data: data.data,
                            smooth: false,
                            itemStyle:{
                                normal:{
                                    color:data.color
                                }
                            },
                            areaStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                        offset: 0,
                                        color: data.color
                                    }, {
                                        offset: 1,
                                        color: '#fff'
                                    }])
                                }
                            }
                        }]
                    }
                    break;
                case 'bar':
                    option = {
                        tooltip : {
                            trigger: 'axis',
                            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                                type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                            },
                            formatter:function(params){
                                var res='<div><p><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:'+data.data[i].color+'"></span>时间：'+params[0].name+'</p></div>'
                                for(var i=0;i<params.length;i++){
                                    var dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:'+data.data[i].color+'"></span>'
                                    res+='<p>'+dotHtml+params[i].seriesName+'：'+params[i].data+data.unit+'</p>'
                                }
                                return res;
                            }
                        },
                        title: {
                            textStyle: {
                                fontWeight: "bold",
                                color: "#161616",
                                fontSize: 16
                            }
                        },
                        legend: {
                            data:data.legend
                        },
                        xAxis: {
                            type: 'category',
                            data: data.xAxis,
                            axisLabel:{
                                color: "#999",
                                fontSize: 12,
                                fontWeight: "normal"
                            },
                            axisLine: {
                                lineStyle: {
                                    type: 'solid',
                                    color: 'transparent',
                                    width:'1'
                                }
                            },
                            splitLine:{
                                show:false
                            }
                        },
                        yAxis: {
                            type: 'value',
                            data:data.yAxis,
                            axisLabel:{
                                color: "#999",
                                fontSize: 12,
                                fontWeight: "normal"
                            },
                            axisLine: {
                                lineStyle: {
                                    type: 'solid',
                                    color: 'transparent',
                                    width:'1'
                                }
                            },
                            splitLine:{
                                show:false
                            }
                        },
                        grid: {
                            left: '4%',
                            right: '4%',
                            containLabel: true
                        },
                        series: data.data
                    }
                    break;
                case 'gauge':
                    option = {
                        tooltip : {
                            formatter: "{a} <br/>{b} : {c}%"
                        },
                        toolbox: {
                            feature: {
                                restore: {},
                                saveAsImage: {}
                            },
                            right: '4%',
                        },
                        grid: {
                            left: '4%',
                            right: '4%',
                            containLabel: true
                        },
                        series: [
                            {
                                name: data.name,
                                type: 'gauge',
                                detail: {formatter:'{value}%'},
                                data: data.data
                            }
                        ]
                    }
                    break;
            }
            return option;
        },
        initChart(data) {
            var _this = this;
            // _this.chart = echarts.init(this.$refs[target], 'light');
            this.chart = echarts.init(this.$el, 'light');
            var final_options = this.getOption(this.type,data);
            if(data.title){
                final_options.title['text'] = data.title;
            }
            if(data.subtitle){
                final_options.title['subtext'] = data.subtitle;
            }
            if(data.textStyle){
                /*final_options = Object.assign({},final_options.title,_this.textStyle);*/
                final_options.title['textStyle'] = data.textStyle;
            }
            if(data.axisLabel){
                final_options.xAxis['axisLabel'] = data.axisLabel;
                final_options.yAxis['axisLabel'] = data.axisLabel;
            }
            if(data.axisLine){
                final_options.xAxis['axisLine'] = data.axisLine;
                final_options.yAxis['axisLine'] = data.axisLine;
            }
            if(data.splitLine){
                final_options.xAxis['splitLine'] = data.splitLine;
                final_options.yAxis['splitLine'] = data.splitLine;
            }
           /* if(data.barWidth){
                final_options.series[0]['barWidth'] = data.barWidth;
            }
            if(data.barMaxWidth){
                final_options.series[0]['barMaxWidth'] = data.barMaxWidth;
            }*/
            if(data.itemStyle){
                var newObj = {};
                Object.assign(newObj,final_options.series[0]['itemStyle'],data.itemStyle);
                final_options.series[0]['itemStyle'] = newObj;
            }
            if(data.xAxisType){
                final_options.xAxis.type = data.xAxisType;
            }
            if(data.yAxisType){
                final_options.yAxis.type = data.yAxisType;
            }
            //console.log(final_options)
            this.chart.setOption(final_options);
        }
    },
}
</script>